import * as React from 'react'
import { GreyBlock, ContainerBlock, StyledFormContainer } from '$views/components/CaretakerCard/CaretakerCard.style'
import { CaretakerDetailsView } from '$domain/model/caretaker/caretakerDetails/caretakerDetails.model'
import { Block, Text } from '$views/components'
import { Stars } from '$views/components/Stars'
import { getQualificationResume } from '$domain/model/recommendation/recommendation.model'
import { RoundedImage } from '$views/components/RoundedImage'

interface Props {
  caretakerDetails: CaretakerDetailsView
}

export const CaretakerCard: React.FC<Props> = ({ caretakerDetails }) => {
  return (
    <GreyBlock>
      <ContainerBlock>
        <StyledFormContainer login>
          <Block flex alignItems="center">
            <RoundedImage
              bordered
              borderColor="white"
              urlImage={caretakerDetails.profilePicture}
              size="normal"
              textImage={caretakerDetails.name}
            />
            <Block marginLeft="mini">
              <Block flex alignItems="baseline">
                <Text capitalize subheader weight="medium" marginRight="base">
                  {caretakerDetails.name.toLowerCase()}
                </Text>
                {caretakerDetails.rating > 0 && <Stars label={caretakerDetails.rating} />}
              </Block>
              <Text color="menu" marginTop="tiny" menu>
                {getQualificationResume(caretakerDetails.mainQualification)}
              </Text>
            </Block>
          </Block>
        </StyledFormContainer>
      </ContainerBlock>
    </GreyBlock>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/CaretakerCard/CaretakerCard.tsx